<div class="outline-settings">
    <p class="outline-settings__info">{{'CONSENT.QUICK_SETTINGS.MENU_DESCRIPTION' | translate}}</p>
    <div class="outline-settings__list">
        <p class="outline-settings__list__title">{{'GENERAL.ADJUST_FONT_SIZE' | translate}}</p>
        <div class="settings-section-font">
            <span class="letter-indication-small">A</span>
            <app-slider
                        [ariaLabel]="'GENERAL.ADJUST_FONT_SIZE' | translate"
                        [values]="values"
                        [selected]="textSize"
                        (sliderChangedEvent)="sliderChangeEvent.emit($event)">
            </app-slider>
            <span class="letter-indication-large">A</span>
        </div>
    </div>
</div>
